module.exports = __webpack_public_path__ + "img/total-coach-order-amount-icon.37f3f8c4.png";